// extracted by mini-css-extract-plugin
module.exports = {"card":"QaAf0","info":"i1yA3","title":"snPjJ","desc":"JBYOo","mods":"dTRFq","actions":"h6FT5","cart-btn":"Rov+v"};